import { ENVIRONMENT } from './environment';
import raid2026Config from './raid2026.json';

// RAID LP 本体とコーポレート TOP/採用導線は公開タイミングが異なる。
// build 時の静的 HTML 生成（scripts/prerender-raid-meta.js）と共有するため
// 値は raid2026.json を単一ソースとする。
export const RAID2026_LP_PUBLISH_AT = raid2026Config.lpPublishAt;
export const RAID2026_CORPORATE_NAV_PUBLISH_AT =
  raid2026Config.corporateNavPublishAt;
export const RAID2026_SPECIAL_SELECTION_START_AT =
  raid2026Config.specialSelectionStartAt;

/** @deprecated corporateNavPublishAt を参照してください */
export const RAID2026_PUBLISH_AT = RAID2026_CORPORATE_NAV_PUBLISH_AT;

const isPublishedAt = (publishAt, now = new Date()) =>
  !ENVIRONMENT.IS_PRODUCTION || now.getTime() >= new Date(publishAt).getTime();

/**
 * raid2026 LP（/recruit/raid2026）が公開済みか判定する純関数。
 * production 以外では常に公開扱い。
 */
export const isRaid2026LpPublished = (now = new Date()) =>
  isPublishedAt(RAID2026_LP_PUBLISH_AT, now);

/**
 * コーポレート TOP / 採用セクションから raid2026 への導線を表示するか判定する純関数。
 * production 以外では常に公開扱い。
 */
export const isRaid2026CorporateNavPublished = (now = new Date()) =>
  isPublishedAt(RAID2026_CORPORATE_NAV_PUBLISH_AT, now);

/** @deprecated isRaid2026CorporateNavPublished を使ってください */
export const isRaid2026Published = isRaid2026CorporateNavPublished;

/**
 * 8/1 からの特別選考表示を先行掲出する時刻（7/31 10:00）に達したか判定する純関数。
 * production 以外では常に特別選考フェーズ扱いにし、stg で先行確認できるようにする。
 */
export const isRaid2026SpecialSelectionStarted = (now = new Date()) =>
  isPublishedAt(RAID2026_SPECIAL_SELECTION_START_AT, now);
